const PROJECT_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getPostLoginPath(from, lastSelectedProject) {
  if (typeof from === "string" && from.startsWith("/") && !from.startsWith("//")) {
    try {
      const url = new URL(from, "https://auth.invalid");
      if (
        url.origin === "https://auth.invalid" &&
        (/^\/(project|user|organization|admin|notice|sample3d)(\/|$)/.test(url.pathname) ||
          url.pathname === "/qr/facility")
      ) {
        return `${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      // Ignore invalid return paths and use the last readable project instead.
    }
  }

  return typeof lastSelectedProject === "string" && PROJECT_ID_PATTERN.test(lastSelectedProject)
    ? `/project/${lastSelectedProject}`
    : "/project";
}
